import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import config from "../constants/config";

Bugsnag.start({
    apiKey: config.BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: [ 'production' ],
})

export const ErrorBoundary = Bugsnag.getPlugin('react')
    .createErrorBoundary(React);
